export default "__VITE_ASSET__DC95p60l__"